import { AuthService } from '../auth/authService';
const BASE_URL = import.meta.env.VITE_API_URL;
export function buildQuery(params) {
    const qs = new URLSearchParams();
    for (const [key, value] of Object.entries(params)) {
        if (value !== undefined && value !== null && value !== '') {
            qs.set(key, String(value));
        }
    }
    const str = qs.toString();
    return str ? `?${str}` : '';
}
export async function request(path, options) {
    const token = AuthService.getAccessToken();
    const res = await fetch(`${BASE_URL}${path}`, {
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
            ...(options?.headers ?? {}),
        },
    });
    if (res.status === 401) {
        AuthService.clearAuth();
        window.location.href = '/login';
        throw new Error('Session expired. Please log in again.');
    }
    const json = await res.json();
    if (!json.success) {
        throw new Error(json.error ?? 'Request failed');
    }
    return json.data;
}
//# sourceMappingURL=apiClient.js.map